import { useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function ArticleWholesale() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <main className="bg-background-50">
      <article>
        <header className="w-full px-6 md:px-10 pt-24 pb-12 md:pt-32 md:pb-16 bg-background-100">
          <div className="max-w-3xl mx-auto">
            <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-500 hover:text-accent-500 transition-colors mb-6">
              <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
              <span>На главную</span>
            </Link>
            <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">Бизнес</span>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-900 leading-tight">
              Оптовые закупки из Китая: руководство для перепродавцов
            </h1>
            <p className="mt-5 text-base md:text-lg text-foreground-500 leading-relaxed">
              Как находить выгодные оптовые партии через YOYBUY Spreadsheet. Расчёт прибыли, стратегии закупок и оптимизация расходов.
            </p>
            <div className="mt-6 flex items-center gap-4 text-xs text-foreground-400">
              <span>Обновлено: Июль 2026</span>
              <span>·</span>
              <span>Время чтения: 7 минут</span>
            </div>
          </div>
        </header>

        <div className="w-full px-6 md:px-10 py-12 md:py-16">
          <div className="max-w-3xl mx-auto">

            <img
              src="https://readdy.ai/api/search-image?query=Bulk%20products%20in%20organized%20grid%20pattern%20on%20modern%20warehouse%20shelf%2C%20professional%20wholesale%20setting%2C%20bright%20clean%20industrial%20lighting%2C%20systematic%20organization%20concept%2C%20b2b%20commerce%20aesthetic%2C%20modern%20inventory%20photography%2C%20rows%20of%20neatly%20packed%20boxes%2C%20efficient%20supply%20chain%20atmosphere&width=1200&height=600&seq=yoybuy-art-wholesale-hero&orientation=landscape"
              alt="Оптовые закупки из Китая"
              className="w-full rounded-3xl mb-10 object-cover"
            />

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Почему оптовые закупки из Китая выгодны</h2>
              <p className="text-base text-foreground-600 leading-relaxed mb-4">
                Китай остаётся мировым центром производства товаров народного потребления. Оптовые закупки напрямую у производителей позволяют получать товары по себестоимости, что даёт маржу от 100% до 500% при перепродаже. <strong>YOYBUY Spreadsheet</strong> упрощает процесс поиска и сравнения оптовых партий через удобные таблицы на <Link to="/" className="text-accent-500 hover:underline">YOYBUY.PRO</Link>.
              </p>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">Стратегия оптовых закупок</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {[
                  { icon: 'ri-search-line', title: 'Анализ рынка', text: 'Изучите спрос в вашем регионе. Какие категории товаров популярны? YOYBUY Spreadsheet охватывает 14 категорий — от одежды до аксессуаров.' },
                  { icon: 'ri-scales-line', title: 'Сравнение цен', text: 'Используйте таблицы для сравнения оптовых цен на аналогичные товары от разных поставщиков. Фильтруйте по минимальной партии и цене за единицу.' },
                  { icon: 'ri-calculator-line', title: 'Расчёт маржи', text: 'Учитывайте все расходы: цена товара + доставка + таможня + упаковка. Ваша целевая маржа должна быть не менее 100% для устойчивого бизнеса.' },
                  { icon: 'ri-truck-line', title: 'Логистика', text: 'Для оптовых партий оптимальна морская или железнодорожная доставка. Это дольше, но значительно снижает себестоимость единицы товара.' },
                ].map((item, i) => (
                  <div key={i} className="p-5 bg-background-100 rounded-2xl">
                    <div className="w-10 h-10 rounded-full bg-accent-100 flex items-center justify-center mb-3">
                      <i className={`${item.icon} text-accent-600`}></i>
                    </div>
                    <h4 className="text-base font-semibold text-foreground-800 mb-2">{item.title}</h4>
                    <p className="text-sm text-foreground-500 leading-relaxed">{item.text}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-12">
              <h2 className="text-2xl md:text-3xl font-heading font-semibold text-foreground-900 mb-5">ТОП категорий для перепродажи</h2>
              <div className="space-y-3">
                {[
                  { cat: 'Обувь', margin: '150-300%', reason: 'Стабильный спрос, широкая размерная сетка, высокая маржинальность дизайнерских моделей.' },
                  { cat: 'Аксессуары', margin: '200-500%', reason: 'Малый вес и объём, низкая стоимость доставки, импульсные покупки.' },
                  { cat: 'Сумки', margin: '150-400%', reason: 'Высокая воспринимаемая ценность, возможность создавать собственный бренд.' },
                  { cat: 'Толстовки и свитера', margin: '100-250%', reason: 'Сезонный пик спроса, оптовые скидки за объём, разнообразие стилей.' },
                ].map((item, i) => (
                  <div key={i} className="flex items-center justify-between p-4 bg-background-100 rounded-xl flex-wrap gap-3">
                    <div>
                      <span className="text-sm font-semibold text-foreground-800">{item.cat}</span>
                      <p className="text-xs text-foreground-500 mt-0.5">{item.reason}</p>
                    </div>
                    <span className="text-sm font-bold text-accent-600 bg-accent-50 px-3 py-1.5 rounded-full whitespace-nowrap">{item.margin}</span>
                  </div>
                ))}
              </div>
            </section>

            <div className="mt-14 p-8 bg-primary-500 rounded-3xl text-center">
              <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-4">Начните оптовые закупки</h2>
              <p className="text-base text-background-50/80 mb-6 max-w-md mx-auto">
                Используйте YOYBUY Spreadsheet для поиска выгодных оптовых партий из 14 категорий товаров.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="px-7 py-3.5 rounded-full bg-background-50 text-primary-600 text-sm font-semibold hover:bg-accent-100 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center">
                  <span>YOYBUY SHEET</span>
                  <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
                </a>
                <Link to="/" className="px-7 py-3.5 rounded-full border-2 border-background-50/40 text-background-50 text-sm font-semibold hover:border-background-50 hover:bg-background-50/10 transition-all whitespace-nowrap cursor-pointer inline-flex items-center gap-2 justify-center">
                  <span>На главную</span>
                  <i className="ri-home-4-line w-4 h-4 flex items-center justify-center"></i>
                </Link>
              </div>
            </div>

            <div className="mt-10 pt-10 border-t border-background-200">
              <Link to="/" className="inline-flex items-center gap-2 text-sm text-foreground-400 hover:text-accent-500 transition-colors">
                <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                <span>← Вернуться на главную страницу YOYBUY.PRO</span>
              </Link>
            </div>
          </div>
        </div>
      </article>

      <footer className="w-full px-6 md:px-10 py-10 bg-foreground-950">
        <div className="max-w-3xl mx-auto text-center">
          <Link to="/" className="text-xl font-heading font-bold text-background-50">YOYBUY<span className="text-accent-500">.PRO</span></Link>
          <p className="mt-3 text-xs text-background-50/30">© 2026 YOYBUY.PRO. Все права защищены.</p>
        </div>
      </footer>

      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org", "@type": "Article",
          "headline": "Оптовые закупки из Китая: руководство для перепродавцов",
          "description": "Как находить выгодные оптовые партии через YOYBUY Spreadsheet. Расчёт прибыли и стратегии закупок.",
          "datePublished": "2026-07-05", "dateModified": "2026-07-05",
          "author": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "publisher": {"@type": "Organization", "name": "YOYBUY.PRO"},
          "mainEntityOfPage": {"@type": "WebPage", "@id": `${import.meta.env.VITE_SITE_URL}/article/china-wholesale-guide`}
        })}
      </script>
    </main>
  );
}